module.exports = __webpack_public_path__ + "files/5d9a900e3ce3ed0e8d53f539f1b33847.png";